"use client";

import { motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";
import { duration, ease } from "@/design/motion";

type RevealProps = {
  children: ReactNode;
  delay?: number;
  className?: string;
};

/**
 * Jemný nájezd obsahu při scrollu. Respektuje prefers-reduced-motion.
 * Animace je izolovaná v client komponentě, obsah zůstává serverový.
 */
export function Reveal({ children, delay = 0, className }: RevealProps) {
  const shouldReduceMotion = useReducedMotion();

  if (shouldReduceMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: duration.normal, delay, ease: ease.standard }}
    >
      {children}
    </motion.div>
  );
}
